import { Typography } from "@hellocarbo/lasagne";
import { ChevronLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link, To } from "react-router";

import SubscriptionCard from "@/components/Pricing/SubscriptionCard";

function Pricing() {
  const { t } = useTranslation("pricing");
  return (
    <div className="mx-xl my-lg bg-grayscale-xx-light min-h-screen">
      <div className="mb-md gap-sm flex items-center">
        <Link to={-1 as To}>
          <ChevronLeft className="size-md text-secondary" />
        </Link>
        <Typography step="3" as="h1">
          {t(`pricing:choosePlan`)}
        </Typography>
      </div>
      <div className="gap-md grid grid-cols-1 lg:grid-cols-3">
        <SubscriptionCard subscriptionType="pro" />
        <SubscriptionCard subscriptionType="essential" />
        <SubscriptionCard subscriptionType="premium" />
      </div>
    </div>
  );
}

export default Pricing;
